import { useBrand } from "core/hooks/useBrand";
import { useRegion } from "./useRegion";

export function useBrandCountryCode() {
  const { brandTwoLetterCode } = useBrand();
  const region = useRegion();
  return `${brandTwoLetterCode}${region}`.toUpperCase();
}
